"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "InitMigrationJobs", {
    enumerable: true,
    get: function() {
        return InitMigrationJobs;
    }
});
const _debug = /*#__PURE__*/ _interop_require_default(require("debug"));
const _uuid = require("uuid");
const _common = require("@nestjs/common");
const _nc_job_008_recover_disconnected_table_name = require("./nc_job_008_recover_disconnected_table_name");
const _Jobs = require("~/interface/Jobs");
const _jobsserviceinterface = require("~/modules/jobs/jobs-service.interface");
const _nc_job_001_attachment = require("~/modules/jobs/migration-jobs/nc_job_001_attachment");
const _nc_job_002_thumbnail = require("~/modules/jobs/migration-jobs/nc_job_002_thumbnail");
const _migrationJobs = require("~/helpers/migrationJobs");
const _nc_job_003_recover_links = require("~/modules/jobs/migration-jobs/nc_job_003_recover_links");
const _nc_job_004_cleanup_duplicate_column = require("~/modules/jobs/migration-jobs/nc_job_004_cleanup_duplicate_column");
const _nc_job_005_order_column = require("~/modules/jobs/migration-jobs/nc_job_005_order_column");
const _nc_job_007_recover_order_column = require("~/modules/jobs/migration-jobs/nc_job_007_recover_order_column");
const _nc_job_no_op = require("~/modules/jobs/migration-jobs/nc_job_no_op");
const _nc_job_009_audit_migration = require("~/modules/jobs/migration-jobs/nc_job_009_audit_migration");
const _utils = require("~/utils");
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _ts_decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function _ts_metadata(k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
}
function _ts_param(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
let InitMigrationJobs = class InitMigrationJobs {
    async job(job) {
        this.debugLog(`job started for ${job.id}`);
        // create a unique id for this run
        const runUuid = (0, _uuid.v4)();
        const migrationJobsState = await (0, _migrationJobs.getMigrationJobsState)();
        // check for stall (no update for 10 mins)
        if (migrationJobsState.locked) {
            if (Date.now() - migrationJobsState.stall_check > 10 * 60 * 1000) {
                migrationJobsState.locked = false;
                migrationJobsState.stall_check = Date.now();
                await (0, _migrationJobs.updateMigrationJobsState)(migrationJobsState);
                return this.job(job);
            }
        }
        // check for lock
        if (migrationJobsState.locked) {
            if (migrationJobsState.instance === runUuid) {
                // lock taken by this instance
                return;
            }
            // migration job is running, make sure it's not stalled by checking after 10 mins
            // stall check is updated every 5 mins
            setTimeout(()=>{
                this.jobsService.add(_Jobs.JobTypes.InitMigrationJobs, {});
            }, 10 * 60 * 1000).unref();
            return;
        }
        // get migrations need to be applied
        const migrations = this.migrationJobsList.filter((m)=>+m.version > +migrationJobsState.version);
        if (!migrations.length) {
            return;
        }
        // lock the migration job
        migrationJobsState.locked = true;
        migrationJobsState.stall_check = Date.now();
        migrationJobsState.instance = runUuid;
        // try to take lock
        await (0, _migrationJobs.updateMigrationJobsState)(migrationJobsState, migrationJobsState);
        // wait for 5 seconds to confirm lock
        await new Promise((resolve)=>setTimeout(resolve, 5000));
        const confirmState = await (0, _migrationJobs.getMigrationJobsState)();
        // check if lock is taken by this instance
        if (confirmState.locked && confirmState.instance === runUuid) {
            // run first migration in the list
            const migration = migrations[0];
            try {
                // set stall interval
                const stallInterval = (0, _migrationJobs.setMigrationJobsStallInterval)();
                let migrated = false;
                try {
                    // run migration (pass service as this context)
                    migrated = await migration.service.job();
                    // prepare state
                    if (migrated) {
                        migrationJobsState.version = migration.version;
                        migrationJobsState.locked = false;
                        migrationJobsState.stall_check = Date.now();
                    } else {
                        migrationJobsState.locked = false;
                        migrationJobsState.stall_check = Date.now();
                    }
                } catch (e) {
                    this.log('Error running migration: ', e);
                    migrationJobsState.locked = false;
                    migrationJobsState.stall_check = Date.now();
                } finally{
                    clearInterval(stallInterval);
                    // update state
                    await (0, _migrationJobs.updateMigrationJobsState)(migrationJobsState);
                    if (migrated) {
                        // run next job
                        this.jobsService.add(_Jobs.JobTypes.InitMigrationJobs, {});
                    }
                }
            } catch (e) {
                this.log('Error running migration: ', e);
            }
        }
        this.debugLog(`job completed for ${job.id}`);
    }
    constructor(jobsService, attachmentMigration, thumbnailMigration, recoverLinksMigration, cleanupDuplicateColumnMigration, orderColumnMigration, recoverOrderColumnMigration, recoverDisconnectedTableNames, noOpMigration, auditMigration){
        this.jobsService = jobsService;
        this.attachmentMigration = attachmentMigration;
        this.thumbnailMigration = thumbnailMigration;
        this.recoverLinksMigration = recoverLinksMigration;
        this.cleanupDuplicateColumnMigration = cleanupDuplicateColumnMigration;
        this.orderColumnMigration = orderColumnMigration;
        this.recoverOrderColumnMigration = recoverOrderColumnMigration;
        this.recoverDisconnectedTableNames = recoverDisconnectedTableNames;
        this.noOpMigration = noOpMigration;
        this.auditMigration = auditMigration;
        this.migrationJobsList = [
            {
                version: '1',
                job: _Jobs.MigrationJobTypes.Attachment,
                service: this.attachmentMigration
            },
            {
                version: '2',
                job: _Jobs.MigrationJobTypes.Thumbnail,
                service: this.thumbnailMigration
            },
            {
                version: '3',
                job: _Jobs.MigrationJobTypes.RecoverLinks,
                service: this.recoverLinksMigration
            },
            {
                version: '4',
                job: _Jobs.MigrationJobTypes.CleanupDuplicateColumns,
                service: this.cleanupDuplicateColumnMigration
            },
            {
                version: '5',
                job: _Jobs.MigrationJobTypes.NoOpMigration,
                service: _utils.isEE ? this.orderColumnMigration : this.noOpMigration
            },
            {
                version: '6',
                job: _Jobs.MigrationJobTypes.OrderColumnCreation,
                service: _utils.isEE ? this.noOpMigration : this.orderColumnMigration
            },
            {
                version: '7',
                job: _Jobs.MigrationJobTypes.RecoverOrderColumnMigration,
                service: _utils.isEE ? this.noOpMigration : this.recoverOrderColumnMigration
            },
            {
                version: '8',
                job: _Jobs.MigrationJobTypes.RecoverDisconnectedTableNames,
                service: this.recoverDisconnectedTableNames
            },
            {
                version: '9',
                job: _Jobs.MigrationJobTypes.AuditMigration,
                service: this.auditMigration
            }
        ];
        this.debugLog = (0, _debug.default)('nc:migration-jobs:init');
        this.log = (...msgs)=>{
            console.log('[init-migration-jobs]: ', ...msgs);
        };
    }
};
InitMigrationJobs = _ts_decorate([
    (0, _common.Injectable)(),
    _ts_param(0, (0, _common.Inject)((0, _common.forwardRef)(()=>'JobsService'))),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _jobsserviceinterface.IJobsService === "undefined" ? Object : _jobsserviceinterface.IJobsService,
        typeof _nc_job_001_attachment.AttachmentMigration === "undefined" ? Object : _nc_job_001_attachment.AttachmentMigration,
        typeof _nc_job_002_thumbnail.ThumbnailMigration === "undefined" ? Object : _nc_job_002_thumbnail.ThumbnailMigration,
        typeof _nc_job_003_recover_links.RecoverLinksMigration === "undefined" ? Object : _nc_job_003_recover_links.RecoverLinksMigration,
        typeof _nc_job_004_cleanup_duplicate_column.CleanupDuplicateColumnMigration === "undefined" ? Object : _nc_job_004_cleanup_duplicate_column.CleanupDuplicateColumnMigration,
        typeof _nc_job_005_order_column.OrderColumnMigration === "undefined" ? Object : _nc_job_005_order_column.OrderColumnMigration,
        typeof _nc_job_007_recover_order_column.RecoverOrderColumnMigration === "undefined" ? Object : _nc_job_007_recover_order_column.RecoverOrderColumnMigration,
        typeof _nc_job_008_recover_disconnected_table_name.RecoverDisconnectedTableNames === "undefined" ? Object : _nc_job_008_recover_disconnected_table_name.RecoverDisconnectedTableNames,
        typeof _nc_job_no_op.NoOpMigration === "undefined" ? Object : _nc_job_no_op.NoOpMigration,
        typeof _nc_job_009_audit_migration.AuditMigration === "undefined" ? Object : _nc_job_009_audit_migration.AuditMigration
    ])
], InitMigrationJobs);
